import template from './collections.html';
import controller from './collections.controller';

let collectionsComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default collectionsComponent;
